<template>
  <v-text-field
    v-model="bindValue"
    :label="$trans('v2.i2m_components.name')"
    @input="emitInput"
  />
</template>

<script>
export default {
  props: {
    value: {
      required: true,
      type: String,
    },
  },
  data() {
    return {
      bindValue: '',
      hasFocus: false,
    };
  },
  watch: {
    value() {
      if (this.value === '') {
        this.bindValue = '';
      }
    },
  },
  methods: {
    emitInput(value) {
      this.$emit('input', value);
    },
  },
};
</script>
